/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { PlatformCategory } from './platform-category';
// May contain unused imports in some cases
// @ts-ignore
import type { SnsAccountAlbaoneFeed } from './sns-account-albaone-feed';
// May contain unused imports in some cases
// @ts-ignore
import type { SnsAccountError } from './sns-account-error';
// May contain unused imports in some cases
// @ts-ignore
import type { User } from './user';

/**
 * 
 * @export
 * @interface SnsAccount
 */
export interface SnsAccount {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof SnsAccount
     */
    'snsAccountUuid': string;
    /**
     * sns 고유키
     * @type {string}
     * @memberof SnsAccount
     */
    'snsUniqueKey': string;
    /**
     * 계정 ID
     * @type {string}
     * @memberof SnsAccount
     */
    'snsId': string;
    /**
     * 계정 링크
     * @type {string}
     * @memberof SnsAccount
     */
    'snsLink': string;
    /**
     * sns 계정 종류
     * @type {string}
     * @memberof SnsAccount
     */
    'snsAccountType': SnsAccountSnsAccountTypeEnum;
    /**
     * 활동기능 여부
     * @type {boolean}
     * @memberof SnsAccount
     */
    'isActivity'?: boolean;
    /**
     * 승인 일시
     * @type {string}
     * @memberof SnsAccount
     */
    'approvedAt': string;
    /**
     * 성별
     * @type {string}
     * @memberof SnsAccount
     */
    'gender': SnsAccountGenderEnum;
    /**
     * 나이
     * @type {number}
     * @memberof SnsAccount
     */
    'age': number;
    /**
     * 적립 금액
     * @type {number}
     * @memberof SnsAccount
     */
    'totalPoint': number;
    /**
     * 관리자 체크 여부
     * @type {boolean}
     * @memberof SnsAccount
     */
    'isCheck': boolean;
    /**
     * 생성 일시
     * @type {string}
     * @memberof SnsAccount
     */
    'createdAt': string;
    /**
     * 수정 일시
     * @type {string}
     * @memberof SnsAccount
     */
    'updatedAt': string;
    /**
     * 삭제 일시
     * @type {string}
     * @memberof SnsAccount
     */
    'deletedAt': string;
    /**
     * 계정 버전
     * @type {number}
     * @memberof SnsAccount
     */
    'version': number;
    /**
     * 유저
     * @type {User}
     * @memberof SnsAccount
     */
    'user': User;
    /**
     * 플렛폼 카테고리
     * @type {PlatformCategory}
     * @memberof SnsAccount
     */
    'platformCategory': PlatformCategory;
    /**
     * sns 계정 에러
     * @type {SnsAccountError}
     * @memberof SnsAccount
     */
    'snsAccountError': SnsAccountError;
    /**
     * sns 계정 알바원 피드
     * @type {SnsAccountAlbaoneFeed}
     * @memberof SnsAccount
     */
    'snsAccountAlbaoneFeed': SnsAccountAlbaoneFeed;
}

export const SnsAccountSnsAccountTypeEnum = {
    Viewup: 'viewup',
    ViewupPlus: 'viewupPlus'
} as const;

export type SnsAccountSnsAccountTypeEnum = typeof SnsAccountSnsAccountTypeEnum[keyof typeof SnsAccountSnsAccountTypeEnum];
export const SnsAccountGenderEnum = {
    M: 'M',
    F: 'F',
    Unknown: 'unknown'
} as const;

export type SnsAccountGenderEnum = typeof SnsAccountGenderEnum[keyof typeof SnsAccountGenderEnum];


